import { useRef } from 'react';
import { css } from '@linaria/atomic';
import { useTranslation } from '@frontend/i18n';
import { CareCreditChip } from '@frontend/payments-care-credit';
import { Button, Text } from '@frontend/design-system';
import { useCollectPaymentMultiContext } from '../../../collect-payment-multi.context';
import { PAYMENT_MULTI_STEP_LABELS, PAYMENT_MULTI_STEPS } from '../../../utils/steps';
import { StyledStep } from '../../atoms/styled-step';
import type { CareCreditEnrollDisclosureBodyProps } from './care-credit-enroll-disclosure.types';

const styles = {
  subheader: css`
    display: flex;
    gap: var(--fabric-space-gap-xs);
    margin-bottom: var(--fabric-space-gap-xs);
    align-items: center;
  `,
};

export const CareCreditEnrollDisclosureBody = ({
  onGoBack,
  onCompleteStep,
  onVerifyStatus,
  onCancel,
}: CareCreditEnrollDisclosureBodyProps) => {
  const { t } = useTranslation();

  const { careCreditData } = useCollectPaymentMultiContext();

  const applicantStatus = careCreditData?.status;

  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <StyledStep
      id={PAYMENT_MULTI_STEPS.careCreditEnrollDisclosure}
      label={PAYMENT_MULTI_STEP_LABELS[PAYMENT_MULTI_STEPS.careCreditEnrollDisclosure]}
      isValid={true}
      footer={{
        showBackButton: true,
        primary: {
          label: t('Check Now'),
        },
        secondary: {
          label: t('Cancel'),
        },
        onClickBack: onGoBack,
        onClickPrimary: onCompleteStep,
        onClickSecondary: onCancel,
      }}
    >
      <div className={styles.subheader}>
        <div ref={containerRef}>
          <CareCreditChip status={applicantStatus} maxWidth='unset' />
        </div>
        <div>
          <Button iconName='user-inspect' variant='tertiary' size='tiny' onClick={onVerifyStatus}>
            {t('Verify CareCredit Status')}
          </Button>
        </div>
      </div>
      <Text>
        {t(
          'Check to see if this customer qualifies for CareCredit financing, either by completing a form in person or sending customer a secure link.  Customer can pay balance after they complete approval.'
        )}
      </Text>
    </StyledStep>
  );
};
